import { render } from "./ProductCategorySlider.vue?vue&type=template&id=7b1f6985"
import script from "./ProductCategorySlider.vue?vue&type=script&lang=js"
export * from "./ProductCategorySlider.vue?vue&type=script&lang=js"

import "./ProductCategorySlider.vue?vue&type=style&index=0&id=7b1f6985&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__